module.exports = __webpack_public_path__ + "static/media/play@3x.12cac885.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/play@3x.png
// module id = 609
// module chunks = 0